<section fxLayout="column" fxLayoutGap="30px">
  <bb-branches></bb-branches>
  <bb-employment-info></bb-employment-info>
  <bb-personal-info></bb-personal-info>
  <div fxFlexAlign="center" fxLayout="row" fxLayoutGap="8px">
    <button mat-raised-button color="primary"
            (click)="backward()">
      <i class="fa fa-caret-left"></i> Previous
    </button>
    <button mat-raised-button color="primary"
            (click)="forward()">
      Next <i class="fa fa-caret-right"></i>
    </button>
  </div>
</section>
